import BaseProxy from './Proxy';

export default class SubstoreStockProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/stock', parameters);
  }

  list(type) {
    return this.submit('get', `${this.endpoint}/list/${type}`);
  }

  /**
   * Perform stock action
   *
   * @param subscriptionTemplateId
   * @param uniqueSubscriptionId
   * @param action
   * @param params
   * @returns {Promise}
   */
  stockAction(subscriptionTemplateId, uniqueSubscriptionId, action, params = {}) {
    return this.submit('post', `${this.endpoint}/subscription/${subscriptionTemplateId}/${uniqueSubscriptionId}/action/${action}`, params);
  }

  /**
   * Select stock product change
   *
   * @param subscriptionTemplateId
   * @param uniqueSubscriptionId
   * @returns {Promise}
   */
  stockProductChangeSelection(subscriptionTemplateId, uniqueSubscriptionId) {
    return this.submit('get', `${this.endpoint}/subscription/${subscriptionTemplateId}/${uniqueSubscriptionId}/change/selection`);
  }

  stockProductChangeSummary(subscriptionTemplateId, uniqueSubscriptionId, newSubscriptionTemplateId) {
    return this.submit('get', `${this.endpoint}/subscription/${subscriptionTemplateId}/${uniqueSubscriptionId}/${newSubscriptionTemplateId}/change/summary`);
  }

  stockProductChangeConfirmation(subscriptionTemplateId, uniqueSubscriptionId) {
    return this.submit('get', `${this.endpoint}/subscription/${subscriptionTemplateId}/${uniqueSubscriptionId}/change/confirmation`);
  }

  getDocuments(subscriptionTemplateId, uniqueSubscriptionId) {
    return this.submit('get', `${this.endpoint}/subscription/${subscriptionTemplateId}/${uniqueSubscriptionId}/documents`);
  }

  documentsResend(subscriptionTemplateId, uniqueSubscriptionId, type, event) {
    return this.submit('post', `${this.endpoint}/subscription/${subscriptionTemplateId}/${uniqueSubscriptionId}/documents/resend`, { type, event });
  }
}
